import { isAgency, isBackoffice, isClient, isGeneral, isInspector } from 'app/helpers/userRoles';
import { useSelector } from 'react-redux';

import { RootState } from '../../../store/rootReducer';

export interface UserNameProps {
  useInitials?: Boolean;
  className?: string;
}

export default function UserName(props: UserNameProps) {
  const { user } = useSelector((state: RootState) => state.auth);

  if (!user) {
    return null;
  }

  let userName = '';

  const isUserInspector = isInspector(user);
  const isUserClient = isClient(user);
  const isUserBackoffice = isBackoffice(user) || isGeneral(user);
  const isUserAgency = isAgency(user);

  if (isUserInspector) {
    userName = user.fullName;
  }
  if (isUserClient) {
    userName = user.firstName;
  }
  if (isUserAgency) {
    userName = user.company?.name || user?.firstName || '';
  }
  if (isUserBackoffice) {
    userName = user.firstName;
  }

  return (
    <>
      {isUserClient && (
        <>
          {user.company?.companyName}
          {user.company?.companyName && <br />}
          {userName}
        </>
      )}
      {isUserInspector && (
        <>
          Inspector, <br />
          {userName}
        </>
      )}
      {isUserBackoffice && (
        <>
          Admin,
          <br />
          {userName}
        </>
      )}
      {isUserAgency && !isUserInspector && <>{user.fullName}</>}
    </>
  );
}
